import { Component } from '@angular/core';

import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FieldBaseComponent } from '@shared/components/forms/components/field-base';
import { FormFieldErrorComponent } from '@shared/components/forms/components/form-field-error/form-field-error.component';

import { NgClass } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-form-select',
  styleUrls: ['form-select.component.scss'],
  templateUrl: 'form-select.component.html',
  imports: [FormsModule, ReactiveFormsModule, NgbTooltip, FormFieldErrorComponent, NgClass],
})
export class FormSelectComponent extends FieldBaseComponent {
  public onChange($event: Event) {
    if (this.config?.onSelectChange) {
      this.config.onSelectChange(($event.target as HTMLInputElement).value);
    }
  }
}
